module.exports = __webpack_public_path__ + "img/Thermometer_green.2506ca76.png";